import request from '@/services/interceptor.js'

export const get_reparti = (macroAreaId) => {
    return request({
        url: '/reparto',
        method: 'get',
        params: macroAreaId ? { macroAreaId } : {},
        loadingBar: true
    })
}

export const get_reparto = (id) => {
    return request({
        url: `/reparto/${id}`,
        method: 'get',
        loadingBar: true
    })
}

export const create_reparto = (par) => {
    return request({
        url: '/reparto',
        method: 'post',
        data: par,
        loadingBar: true
    })
}

export const update_reparto = (id, par) => {
    return request({
        url: `/reparto/${id}`,
        method: 'put',
        data: par,
        loadingBar: true
    })
}

export const delete_reparto = (id) => {
    return request({
        url: `/reparto/${id}`,
        method: 'delete',
        loadingBar: true
    })
}